<div class="row">
  <div class="col-6">
    <h2><i class="fas fa-file-import"></i> Apsis One Migraions</h2>
  </div>
</div>

<migrations-charts
  [successfulMigrations]="successfulMigrations$ | async"
  [failedMigrations]="failedMigrations$ | async"
  [isLoadingAccounts]="isLoadingAccounts$ | async"
  (changeChartPeriod)="setDateInterval($event)"
>
</migrations-charts>

<div class="row margin-top-bottom-20px">
  <div class="col-4">
    <app-search-bar
      placeholder="Find account by ID (min 3 characters)"
      (handleSearch)="loadAccounts($event)"
    ></app-search-bar>
  </div>
  <div class="col">
    <migrations-state-filter
      [filterArray]="filterStateArray"
      (filter)="onFilterChange($event)"
    ></migrations-state-filter>
  </div>
</div>
<app-migrations-accounts-table
  [migrations]="migrations$ | async"
  [searchQuery]="search$ | async"
  [stateFilter]="stateFilter$ | async"
  [fixedHeader]="true"
  [isLoadingAccounts]="isLoadingAccounts$ | async"
  (openMigrationModal)="openMigrationModal($event)"
  (getMigrationReport)="getMigrationReport($event)"
>
</app-migrations-accounts-table>
